import sortBy from 'lodash/sortBy';
import industryConfig from 'wwg-utilities/dist/config/industryConfig';
import project from './project';

const config = {
  skillup: [
    {
      label: 'Industry',
      paramLabel: 'industry',
      options: sortBy(industryConfig.skillup.careerFields).filter(
        (cf) => cf != 'Other',
      ),
    },
    {
      label: 'Minimum Salary',
      paramLabel: 'salary',
      options: [
        '$15/hr $31k/yr',
        '$20/hr $41k/yr',
        '$25/hr $52k/yr',
        '$30/hr $62k/yr',
        '$35/hr $75k/yr',
        '$40/hr+ $83k/yr+',
      ],
    },
    {
      label: 'Work Style',
      paramLabel: 'style',
      options: [
        'Artistic',
        'Conventional',
        'Enterprising',
        'Investigative',
        'Realistic',
        'Social',
      ],
    },
  ],
  wherewego: [
    {
      label: 'Style',
      paramLabel: 'style',
      options: [
        'Realistic',
        'Investigative',
        'Artistic',
        'Social',
        'Enterprising',
        'Conventional',
      ],
    },
    {
      label: 'Training Length',
      paramLabel: 'length',
      options: [
        'Days to months',
        'Up to 1 year',
        'Up to 1-2 years',
        'Up to 4 years',
        'More than 4 years',
      ],
    },
    {
      label: 'Outlook',
      paramLabel: 'outlook',
      options: ['Average', 'Below Average', 'Bright'],
    },
    {
      label: 'Minimum Salary',
      paramLabel: 'salary',
      options: [
        '$15/hr or $31K/yr',
        '$25/hr or $52K/yr',
        '$40/hr or $83K/yr',
        '$50/hr or $105K/yr',
      ],
    },
    {
      label: 'Industry',
      paramLabel: 'industry',
      options: [
        'Other',
        'Digital Media & Tech',
        'Skilled Trades',
        'Business Services',
        'Healthcare',
      ],
    },
  ],
};

const careerFilterOptions = config[project];

export default careerFilterOptions;
